/* eslint-disable no-unused-expressions */
import { ref as dbRef, get, set, push, update } from "firebase/database";
import { ref as stoRef, uploadBytes, getDownloadURL, listAll, deleteObject } from "firebase/storage";
import { get as lodashGet, isEqual } from 'lodash';

export const valueFilter = (value, record, key) => {
  const refValue = lodashGet(record, key);
  return isEqual(value, refValue);
};

export const greaterFilter = (value, record, key) => {
  const refValue = lodashGet(record, key);
  return refValue >= value;
};

export const emptyFilter = (value, record, key) => {
  if (value) {
    return record[key] || record[key]?.toString()?.length > 0;
  } else {
    return !record[key] || record[key]?.toString()?.length === 0;
  }
};

export const alphabetSort = (a, b, key) => {
  const valueA = a[key]?.toString()?.toLowerCase() || '';
  const valueB = b[key]?.toString()?.toLowerCase() || '';
  return valueA.localeCompare(valueB, undefined, { numeric: true });
};

// remove all undefined, null or empty fields
export const removeEmptyFields = (data) => {
  Object.keys(data).forEach(key => {
    if (data[key] === undefined || data[key] === null || data[key] === '') {
      delete data[key];
    }
  });
  return data;
};

//convert array of ids to null-value properties object. Eg: [1,2,3] => {1:null,2:null,3:null}
export const toNullPropsObj = (data) => {
  const result = {};
  data.forEach(item => {
    result[item] = null;
  });
  return result;
};

export const getRandomHexColor = () => {
  return '#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
};

export function invertColor(hex, bw) {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function adjustColor(color, amount) {
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

// keep deleting recursively until there is no item/prefix left
export async function deleteFileRecursively(ref) {
  const { items, prefixes } = await listAll(ref);
  // console.log('items:', items, 'prefixes:', prefixes);
  items.forEach(item => deleteObject(item));
  prefixes.forEach(prefix => deleteFileRecursively(prefix));
};

export function isUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}